import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import type { CrossAxisOverflow, ScrollDirection } from './Cscrollable.types';
import { getScrollableStyle } from './scrollableStyles';

interface UseCscrollableStyleInput {
  direction: ScrollDirection;
  crossAxisOverflow: CrossAxisOverflow;
  crossAxisBleed: number;
  fadeSize: number;
  firstItemSpacing: CSSProperties['paddingTop'];
  style?: CSSProperties;
}

export function useCscrollableStyle({
  direction,
  crossAxisOverflow,
  crossAxisBleed,
  fadeSize,
  firstItemSpacing,
  style,
}: UseCscrollableStyleInput): CSSProperties {
  return useMemo(
    () => getScrollableStyle({
      direction,
      crossAxisOverflow,
      crossAxisBleed,
      fadeSize,
      firstItemSpacing,
      style,
    }),
    [direction, crossAxisOverflow, crossAxisBleed, fadeSize, firstItemSpacing, style],
  );
}
